import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "../lib/api";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const blank = () => ({ id: crypto.randomUUID(), title: "", text: "", image_path: null, image_url: null });

function Block({ it, i, total, onChange, onMove, onRemove }) {
  const [uploading, setUploading] = useState(false);
  const upload = async (file) => {
    const fd = new FormData();
    fd.append("file", file);
    setUploading(true);
    try {
      const { data } = await api.post("/admin/platform/image", fd);
      onChange({ ...it, ...data });
    } catch (e) { toast.error(errMsg(e, "No se pudo subir la imagen")); }
    finally { setUploading(false); }
  };
  return (
    <div data-testid={`info-block-${i}`} className="border border-white/10 p-4 space-y-3">
      <div className="flex items-center justify-between gap-2">
        <span className="overline">Bloque {i + 1}</span>
        <div className="flex gap-2">
          <button data-testid={`info-up-${i}`} disabled={i === 0} onClick={() => onMove(i, -1)} className="btn-ghost !py-1 !px-2 text-xs disabled:opacity-30">↑</button>
          <button data-testid={`info-down-${i}`} disabled={i === total - 1} onClick={() => onMove(i, 1)} className="btn-ghost !py-1 !px-2 text-xs disabled:opacity-30">↓</button>
          <button data-testid={`info-delete-${i}`} onClick={onRemove} className="btn-ghost !py-1 !px-2 text-xs hover:!text-red-400">Borrar</button>
        </div>
      </div>
      <input data-testid={`info-title-${i}`} className="input-field" placeholder="Ej: ¿Qué son los tránsitos?"
        value={it.title} onChange={(e) => onChange({ ...it, title: e.target.value })} />
      <textarea data-testid={`info-text-${i}`} rows={5} className="input-field" placeholder="Explicación…"
        value={it.text} onChange={(e) => onChange({ ...it, text: e.target.value })} />
      <div className="flex flex-wrap items-center gap-4">
        {it.image_url && <img src={`${BACKEND_URL}${it.image_url}`} alt="" className="h-20 border border-white/10" />}
        <label className="btn-ghost !py-2 !px-3 text-xs cursor-pointer">
          {uploading ? "Subiendo…" : it.image_url ? "Cambiar imagen" : "+ Imagen (opcional)"}
          <input type="file" accept="image/*" className="hidden" data-testid={`info-image-${i}`} disabled={uploading}
            onChange={(e) => { const f = e.target.files?.[0]; if (f) upload(f); e.target.value = ""; }} />
        </label>
        {it.image_url && (
          <button data-testid={`info-image-remove-${i}`} onClick={() => onChange({ ...it, image_path: null, image_url: null })}
            className="text-xs text-zinc-500 hover:text-red-400">Quitar imagen</button>
        )}
      </div>
    </div>
  );
}

export default function InfoBlocksEditor() {
  const [items, setItems] = useState(null);
  const [saving, setSaving] = useState(false);
  useEffect(() => { api.get("/platform/info").then(({ data }) => setItems(data.items)).catch(() => setItems([])); }, []);

  const move = (i, d) => setItems((xs) => { const n = [...xs]; [n[i], n[i + d]] = [n[i + d], n[i]]; return n; });
  const save = async () => {
    if (items.some((x) => !x.title.trim())) { toast.error("Cada bloque necesita un título"); return; }
    setSaving(true);
    try {
      const { data } = await api.put("/admin/platform/info", {
        items: items.map(({ id, title, text, image_path }) => ({ id, title, text, image_path })),
      });
      setItems(data.items);
      toast.success("Explicaciones guardadas ✦");
    } catch (e) { toast.error(errMsg(e, "No se pudo guardar")); }
    finally { setSaving(false); }
  };

  if (!items) return <p className="text-zinc-500 text-sm">Cargando…</p>;
  return (
    <div data-testid="info-blocks-editor" className="space-y-4">
      <p className="text-zinc-400 text-sm">
        Aparecen en el panel del usuario dentro del desplegable «¿Qué significa?», al abrir sus tránsitos.
      </p>
      {items.map((it, i) => (
        <Block key={it.id} it={it} i={i} total={items.length} onMove={move}
          onChange={(n) => setItems((xs) => xs.map((x) => (x.id === it.id ? n : x)))}
          onRemove={() => window.confirm("¿Borrar este bloque?") && setItems((xs) => xs.filter((x) => x.id !== it.id))} />
      ))}
      <div className="flex flex-wrap gap-3">
        <button data-testid="info-add" onClick={() => setItems((xs) => [...xs, blank()])} className="btn-ghost text-sm">+ Agregar bloque</button>
        <button data-testid="info-save" onClick={save} disabled={saving} className="btn-lilac text-sm">
          {saving ? "Guardando…" : "Guardar explicaciones ✦"}
        </button>
      </div>
    </div>
  );
}
